"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var React = require("react");
/* tslint:enable */
var Utilities_1 = require("../../../Utilities");
var Icon_1 = require("../../../Icon");
var stylesImport = require("./TagItem.scss");
var styles = stylesImport;
exports.TagItem = function (props) { return (React.createElement("div", { className: Utilities_1.css('ms-TagItem', styles.root, { 'is-selected': props.selected }, props.selected && styles.isSelected), key: props.index, "data-selection-index": props.index, "data-is-focusable": !props.disabled && true },
    React.createElement("span", { className: Utilities_1.css('ms-TagItem-text', styles.tagItemText), "aria-label": props.children }, props.children),
    !props.disabled &&
        React.createElement("span", { className: Utilities_1.css('ms-TagItem-close', styles.tagItemClose), onClick: props.onRemoveItem },
            React.createElement(Icon_1.Icon, { iconName: 'Cancel' })))); };
//# sourceMappingURL=TagItem.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/pickers/TagPicker/TagItem.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/pickers/TagPicker/TagItem.js
// module chunks = 1